"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var AccountFrame = /** @class */ (function (_super) {
    __extends(AccountFrame, _super);
    function AccountFrame() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccountFrame.prototype.render = function () {
        var bgImage = this.props.data.section.account.settings.background_image;
        var breadcrumbsLinks = this.props.data.breadcrumbs.links;
        var title = breadcrumbsLinks.length > 2 ? breadcrumbsLinks.pop().title : "Dashboard";
        return (React.createElement("div", { className: "bg-very-light-pink pb-4-8" },
            React.createElement(Snippets.Container, { tag: "section", width: "xl", className: "px-1-6 md:px-11" },
                React.createElement(Snippets.Breadcrumbs, __assign({ className: "py-1-2" }, this.props))),
            React.createElement(Snippets.Container, { className: "mb-2-4 md:mb-1-4", tag: "section", width: "full", bgImage: bgImage },
                React.createElement(Snippets.Container, { width: "xl", className: "px-1-6 md:px-11" },
                    React.createElement("div", { className: "w-full pl-2-8 md:pl-1/8 py-5-6 md:py-9-6 text-arctic text-xmd md:text-48 font-bold leading-none capitalize" }, title))),
            React.createElement(Snippets.Container, { width: "md", className: "px-1-6 md:px-11", tag: "section" },
                React.createElement("div", { className: "w-full flex-1 px-0 md:px-5" }, this.props.children))));
    };
    return AccountFrame;
}(React.PureComponent));
exports.AccountFrame = AccountFrame;
